(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-validate-voucher-code.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-validate-voucher-code.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const useValidateVoucherCode = _ref => {
  let voucherCode = _ref.voucherCode,
    onClose = _ref.onClose;
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isChecking = _useState2[0],
    setIsChecking = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    invalidCode = _useState4[0],
    setInvalidCode = _useState4[1];
  const mountedRef = useRef(null);
  useEffect(() => {
    mountedRef.current = true;
    const validateVoucherCode = async () => {
      svs.ui.loader.show();
      try {
        svs.ticketgames.ticketUtility.logger.info('Checking if voucherCode is redeemable..');
        await svs.ticketgames.ticketUtility.utils.getVoucherCode(voucherCode);
        if (mountedRef.current) {
          setIsChecking(false);
          setInvalidCode(false);
        }
        svs.ticketgames.ticketUtility.logger.info('VoucherCode is redeemable..');
      } catch (e) {
        mountedRef.current && setInvalidCode(true);
        svs.ticketgames.ticketUtility.logger.warn("VoucherCode is already claimed or invalid: ".concat(e));
        svs.tur.apierrors.showErrorMessage({
          onConfirm: onClose,
          response: 0
        });
      }
      mountedRef.current && setIsChecking(false);
      svs.ui.loader.hide();
    };
    validateVoucherCode();
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return {
    isChecking,
    invalidCode
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useValidateVoucherCode', useValidateVoucherCode);

 })(window);